<app-top-bar></app-top-bar>
@if (isCustomBoxSignupFlow()) {
<header class="bg-white top-header" [ngClass]="{'top-header--hidden-sub-nav': !shouldShowCategoriesBar()}">
  <nav class="navbar navbar-expand-lg navbar-light nav-main">
    <span class="navbar-brand animated fadeInLeft" [class.mx-auto]="isCustomBoxSignupFlow()">
      <img src="assets/images/logo-main.svg" alt="Locavore Delivery Logo" width="119" height="35" loading="eager" decoding="sync" />
    </span>
  </nav>
</header>
} @else {
<!--Main Navigation-->
<header class="bg-white top-header" [ngClass]="{'top-header--hidden-sub-nav': !shouldShowCategoriesBar()}">
  <nav class="navbar navbar-expand-lg navbar-light nav-main">
    <!-- Container wrapper -->
    <!-- Toggle button -->
    @if (!isCustomBoxSignupFlow()) {
    <button class="navbar-toggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar"
      aria-controls="offcanvasNavbar" aria-label="Toggle navigation">
      <span class="material-symbols-outlined">menu</span>
    </button>
    }

    <!-- Navbar brand -->
    <a class="navbar-brand animated fadeInLeft" [class.mx-auto]="isCustomBoxSignupFlow() "
      href="https://locavoredelivery.com/" aria-label="Go to homepage">
      <img src="assets/images/logo-main.svg?v={{logoVersionNumber()}}" alt="Locavore Delivery Logo" width="119"
        height="35" loading="eager" decoding="sync" />
    </a>

    @if (!isCustomBoxSignupFlow()) {
    <div class="d-lg-none">
      <button class="search-toggler show-on-shop" (click)="toggleSearchMobile()">
        <span class="material-symbols-outlined">search</span>
      </button>
    </div>

    <div class="offcanvas offcanvas-start d-lg-none mobile-menu" [class.hidden-mobile-footer]="!isShowingMobileFooter()"
      data-bs-backdrop="true" tabindex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
      <div class="offcanvas-body">
        <ul class="navbar-nav justify-content-end flex-grow-1">
          @for (page of landingPages(); track $index) {
          <li class="nav-item">
            @if (page.isInternal) {
            <a class="nav-link" [routerLink]="[page.url]" target="_self" data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
              {{page.name}}
            </a>
            } @else {
            <a class="nav-link" [href]="[page.url]" target="_self">
              {{page.name}}
            </a>
            }

            @if (page.submenu) {
            <ul class="nav-submenu">
              @for (submenu of page.submenu; track $index) {
              <li>
                @if (submenu.isInternal) {
                <a class="nav-link" [routerLink]="[submenu.url]" target="_self" data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
                  {{submenu.name}}
                </a>
                } @else {
                <a class="nav-link" [href]="[submenu.url]" target="_self">
                  {{submenu.name}}
                </a>
                }
              </li>
              }
            </ul>
            }

          </li>
          }
        </ul>
        <hr>

        @if (hydrated()) {
        @if (!signalsStoreService.hasSession()) {
        <ul class="navbar-nav justify-content-end flex-grow-1 gap-2">
          <li>
            <button routerLink="/login" class="btn btn-light w-100" type="button" data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">Log In</button>
          </li>
          <li>
            <button routerLink="/signup" class="btn btn-outline-secondary w-100" type="button"
              data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
              Join
            </button>
          </li>
        </ul>
        } @else {
        <ul class="navbar-nav justify-content-end flex-grow-1 mobile-menu__sub">
          <li>
            <a class="mobile-menu__title mobile-menu__title--action" data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar" routerLink="/order">
              <span class="icon material-symbols-outlined" aria-hidden="true">speed</span>
              <span>Customer Dashboard</span>
            </a>
          </li>
          @for (parent of settingsPages(); track $index) {
          <p class="mobile-menu__title">
            <span class="icon material-symbols-outlined">
              {{parent.icon}}
            </span>
            <span>{{parent.name}}</span>
          </p>
          @for (page of parent.children; track $index) {
          <li>
            <a class="nav-link" data-bs-toggle="offcanvas" data-bs-target="#offcanvasNavbar"
              aria-controls="offcanvasNavbar" [routerLink]="[page.route]">{{page.name2 &&
              !(session()?.settings?.requireAddress) ? page.name2 : page.name}}</a>
          </li>
          }
          }
          <hr>
          <li>
            <span class="nav-link with-action" (click)="logOut()">
              <p class="m-0">{{ userName() }}</p>
              <span class="material-symbols-outlined">login</span>
            </span>
          </li>
        </ul>
        }
        }

      </div>
    </div>

    <!-- Collapsible wrapper -->
    <div class="collapse navbar-collapse justify-content-center" id="navbarNav">
      <!-- Center elements -->
      <ul class="navbar-nav justify-content-end nav-main animated fadeInDown">
        @for (page of landingPages(); track $index) {
        <li class="nav-item" [class.has-sub-menu]="page.submenu">
          <a class="nav-link fw-semibold" [href]="page.url" target="_self">{{page.name}}</a>
          @if (page.submenu) {
          <ul class="sub-menu">
            @for (item of page.submenu; track $index) {
            <li><a class="nav-link" [href]="item.url" target="_self">{{item.name}}</a></li>
            }
          </ul>
          }
        </li>
        }
      </ul>

      @defer (on viewport; when isSessionLoaded()) {
      @if (!signalsStoreService.hasSession()) {
      <div class="navbar-nav justify-content-end animated fadeIn">
        <button routerLink="/login" class="btn btn-light me-2" type="button">LogIn</button>
        <button routerLink="/signup" class="btn btn-outline-secondary" type="button"> Join
        </button>
      </div>
      } @else {
      <!-- Right elements -->
      <ul class="navbar-nav justify-content-end animated fadeIn">
        <!-- Icon -->
        @for (element of rightElements(); track $index) {
        <li class="nav-item nav-item--icon">
          <a class="nav-link fw-semibold" routerLinkActive="active-link" [routerLink]="[element.route]"
            [ngbTooltip]="element.tooltip" placement="bottom" [attr.aria-label]="element.tooltip">
            <div class="position-relative">
              <span class="material-symbols-outlined" aria-hidden="true">
                {{element.icon}}
              </span>
              @if (element.showBadge && orderProductsQuantity()) {
              <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill quanity-badge">
                {{ orderProductsQuantity() }}
                <span class="visually-hidden">unread messages</span>
              </span>
              }
            </div>
          </a>
        </li>
        }
        <div class="vr border border-primary mx-2"></div>
        <li class="nav-item dropdown d-flex align-items-center">
          <a class="nav-link fw-semibold dropdown-toggle dropdown-toggle-split" href="javascript:void(0)" role="button"
            data-bs-toggle="dropdown" aria-expanded="false" data-bs-reference="parent">
            {{ userName() }}
          </a>
          <ul class="dropdown-menu dropdown-menu-end">
            <!-- Standalone entry: same destination as the cart icon above, rendered
                 with the group-header look because it has no children of its own. -->
            <li>
              <a class="dropdown-header dropdown-header--action" routerLink="/order">
                <span class="icon material-symbols-outlined" aria-hidden="true">speed</span>
                <span>Customer Dashboard</span>
              </a>
            </li>
            @for (parent of settingsPages(); track $index) {
            <h6 class="dropdown-header">
              <span class="icon material-symbols-outlined">
                {{parent.icon}}
              </span>
              <span>{{parent.name}}</span>
            </h6>
            @for (page of parent.children; track $index) {
            <li>
              <a class="dropdown-item" [routerLink]="[page.route]">{{page.name2 &&
                !(session()?.settings?.requireAddress) ? page.name2 : page.name}}</a>
            </li>
            }
            }
            <div class="dropdown-divider"></div>
            <li (click)="logOut()">
              <span class="nav-link with-action cursor-pointer">
                <span class="material-symbols-outlined rotate-icon">
                  login
                </span>
                <span>Log out</span>
              </span>
            </li>
          </ul>
        </li>
      </ul>
      }
      } @placeholder {
      <div class="placeholder-glow col-1 animated fadeIn">
        <li class="placeholder col-12 bg-secondary"></li>
      </div>
      }

    </div>
    }
  </nav>

  @if (!isCustomBoxSignupFlow()) {
  <!-- Navbar Inferior -->
  <nav class="navbar navbar-expand-lg navbar-dark bg-secondary-600 nav-category nav-category--desktop animated fadeIn">
    <!-- Centered links -->
    @if (isShowingSearchBar()) {
    <app-search-bar class="w-100 h-100"></app-search-bar>
    } @else {
    <div class="nav-content animated fadeIn">
      <ul class="navbar-nav d-flex align-items-center categories-container">
        @if (menuItems().length) {
        @for (item of menuItems(); track $index) {
        <li class="nav-item animated fadeIn">
          <a class="nav-link text-white" [routerLink]="['/shop', getCategoryUrl(item.name)]"
            [class.text-green]="item.name === 'Holiday Market'"
            [class.text-secondary]="signalsStoreService.selectedCategory().name.toLowerCase() === item.name.toLowerCase()"
            [class.fw-medium]="signalsStoreService.selectedCategory().name.toLowerCase() === item.name.toLowerCase()"
            (click)="triggerCategoryInfoFetch(item)">{{ item.name }}</a>
        </li>
        }
        <li class="nav-item">
          <button class="btn btn-sm nav-category--icon" type="button" (click)="toggleSearchBar()" title="Search">
            <span class="material-symbols-outlined text-white">search</span>
          </button>
        </li>
        }
      </ul>
    </div>
    }
  </nav>

  <!-- Mobile navbar -->
  <nav class="navbar navbar-expand-lg navbar-dark bg-primary nav-category nav-category--mobile animated fadeIn">
    @if (isShowingSearchMobile()) {
    <div class="category-search--mobile">
      <app-search-bar></app-search-bar>
    </div>
    } @else {
    <mat-form-field>
      <mat-label>Category</mat-label>
      <mat-select #matSelect [disabled]="isContentLoading()" [value]="signalsStoreService.selectedCategory().name">
        @if (menuItems().length) {
        @for (item of menuItems(); track $index) {
        <mat-option [value]="item.name" (click)="triggerCategoryInfoFetch(item)">{{ item.name }}</mat-option>
        }
        }
      </mat-select>
    </mat-form-field>
    }
    <div class="category-menu show-on-shop">
      @if (isShowingSearchMobile()) {
      <button type="button" class="category-menu__icon" (click)="toggleSearchMobile()" aria-label="Close search">
        <span class="material-symbols-outlined" aria-hidden="true">close</span>
      </button>
      } @else {
      <button type="button" class="category-menu__icon btn-filter-mobile" (click)="toggleCategorySideMenu()"
        [class.is-open]="!isSidebarOpen()" [attr.aria-label]="isSidebarOpen() ? 'Close filters' : 'Open filters'"
        [attr.aria-expanded]="!isSidebarOpen()">
        <span class="fas fa-sliders icon-sort fs-5" aria-hidden="true"></span>
        <span class="material-symbols-outlined icon-close" aria-hidden="true">close</span>
      </button>
      }
    </div>
  </nav>
  }

</header>
<!--Main Navigation-->
}